import React from "react";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import Home_Page from "./Home_Page/Home_Page";
import Terms_of_Services from "./components/Terms_of_Services/Terms_of_Services";
import Privacy_Policy_DPDP from "./components/Privacy_Policy_DPDP/Privacy_Policy_DPDP";
import Privacy_Policy from "./components/Privacy_Policy/Privacy_Policy";
import Media_Community_Policy from "./components/Media_Community_Policy/Media_Community_Policy";
import Login from "./pages/Login";
import OAuthCallback from "./pages/OAuthCallback";
import DeleteAccount from "./pages/DeleteAccount";
import AccountDeleted from "./pages/AccountDeleted";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home_Page />} />
          <Route path="/Terms_of_use" element={<Terms_of_Services />} />
          <Route path="/Privacy_Policy" element={<Privacy_Policy_DPDP />} />
          <Route path="/Copyright_music_policy" element={<Privacy_Policy />} />
          <Route
            path="/Boloindia_Community_Guidelines"
            element={<Media_Community_Policy />}
          />
          <Route path="/Login" element={<Login />} />
          <Route path="/auth/callback/:provider" element={<OAuthCallback />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/account-deleted" element={<AccountDeleted />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
